import { App } from 'vue';
import { CircularLoaderKey } from '@/symbols';
import { useProgressCircularLoader } from '@/util/progress-circular-loader';

export default {
    install(app: App) {
        const circularLoader = useProgressCircularLoader();
        app.config.globalProperties.$progressCircularBar = circularLoader;
        app.provide(CircularLoaderKey, circularLoader);
    }
};

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $progressCircularBar: any
    }
}
